var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 4.33797C15.5761 4.01479 15.3996 3.7222 15.156 3.4913C14.9056 3.25331 14.5986 3.08306 14.264 2.99664C13.012 2.66664 7.99605 2.66664 7.99605 2.66664C5.90493 2.64284 3.81433 2.74749 1.73605 2.97997C1.40151 3.07278 1.09509 3.24683 0.844045 3.48664C0.597379 3.72397 0.418712 4.01664 0.325379 4.3373C0.101174 5.54513 -0.00776008 6.77153 4.52446e-05 7.99997C-0.00795476 9.2273 0.100712 10.4533 0.325379 11.6626C0.416712 11.982 0.594712 12.2733 0.842045 12.5086C1.08938 12.744 1.39738 12.914 1.73605 13.004C3.00471 13.3333 7.99605 13.3333 7.99605 13.3333C10.0898 13.3571 12.1831 13.2525 14.264 13.02C14.5986 12.9335 14.9056 12.7633 15.156 12.5253C15.3996 12.2945 15.5758 12.0018 15.666 11.6786C15.8961 10.4713 16.008 9.24436 16 8.0153C16.0173 6.78104 15.9056 5.54835 15.6667 4.3373V4.33797ZM6.40138 10.2826V5.71797L10.5747 8.00064L6.40138 10.2826Z",
    fill: "#EFEFEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeFooter);
export default __webpack_public_path__ + "static/media/Youtube_Footer.bb5bd0f6a7e3a16575f1ce2bbd9cee02.svg";
export { ForwardRef as ReactComponent };